import {
  AppPageHeader,
  ColumnsType,
  InfiniteTable,
} from '@/components/_common';
import { useSaleItemHistory } from '@/core/domain/sales/SaleItem/SaleItem.hooks';
import {
  SaleItemHistoryRequest,
  SaleItemHistoryResponse,
} from '@/core/domain/sales/SaleItem/SaleItem.types';
import { useDebounce } from '@/hooks';
import formatterPrice from '@/utils/number/formatterPrice';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Modal, ModalProps } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import DirectSalePartsHistoryExtraFilters from '../DirectSalePartsHistoryExtraFilters';
import formatterPercent from '@/utils/number/formatterPercent';

interface Props extends ModalProps {
  partId?: number;
  partDescription?: string;
  open: boolean;
  onCancel: VoidFunction;
}

const DirectSalePartsHistoryModal: React.FC<Props> = ({
  partId,
  partDescription,
  open,
  onCancel,
  ...props
}) => {
  const [queryParams, setQueryParams] = useState<SaleItemHistoryRequest>({
    order: 'DESC',
  });
  const queryDebounce = useDebounce(queryParams);

  const saleItemHistory = useSaleItemHistory(
    { partId, ...queryDebounce },
    !!partId && open,
  );
  const itemHistory = flatInfiniteData(saleItemHistory.data);

  const columns: ColumnsType<SaleItemHistoryResponse> = [
    {
      dataIndex: 'saleCode',
      title: 'Código de venda',
    },
    {
      dataIndex: 'customerName',
      title: 'Cliente',
    },
    {
      dataIndex: 'unitPrice',
      title: 'Preço unitário',
      render: (value) => (value ? formatterPrice(value) : '-'),
    },
    {
      dataIndex: 'discountValue',
      title: 'Desconto $',
      render: (value) => (value ? formatterPrice(value) : '-'),
    },
    {
      dataIndex: 'discountPercentage',
      title: 'Desconto %',
      render: (value) => (value ? formatterPercent(value / 100) : '-'),
    },
    {
      dataIndex: 'quantity',
      title: 'Quantidade',
    },
    {
      dataIndex: 'totalValue',
      title: 'Valor total',
      render: (value) => (value ? formatterPrice(value) : '-'),
    },

    {
      dataIndex: 'createDate',
      title: 'Data de criação',
      render: (value) => (value ? moment(value).format('DD/MM/YYYY') : '-'),
    },
    {
      dataIndex: 'saleDate',
      title: 'Data da venda',
      render: (value) => (value ? moment(value).format('DD/MM/YYYY') : '-'),
    },
  ];

  const handleCancel = () => {
    onCancel();
  };

  return (
    <Modal
      {...props}
      title={`Histórico da peça ${partDescription}`}
      width={1000}
      open={open}
      onCancel={handleCancel}
      footer={false}
    >
      <AppPageHeader
        extraFilters={
          <DirectSalePartsHistoryExtraFilters
            queryParams={queryParams}
            setQueryParams={setQueryParams}
          />
        }
      />

      <InfiniteTable<SaleItemHistoryResponse>
        columns={columns}
        dataSource={itemHistory}
        rowKey={(row) => row.id}
        loading={saleItemHistory.isLoading}
        hasNextPage={saleItemHistory.hasNextPage}
        fetchNextPage={saleItemHistory.fetchNextPage}
      />
    </Modal>
  );
};

export default DirectSalePartsHistoryModal;
